// Кнопка «наверх»: появляется после прокрутки, рисует прогресс страницы
// в кольце (css-переменная --scroll-progress) и по клику плавно скроллит вверх.
// Разметка: components/footer.php, стили: src/scss/components/_scroll-top.scss.

const VISIBLE_AFTER_VIEWPORT_RATIO = 0.6;

export function scrollTopButton() {
    const $button = document.querySelector(".scroll-top");
    if (!$button) return;

    let rafId = null;

    const update = () => {
        rafId = null;

        const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        const progress = maxScroll > 0 ? Math.min(window.scrollY / maxScroll, 1) : 0;

        $button.style.setProperty("--scroll-progress", progress.toFixed(4));
        $button.classList.toggle("is-visible", window.scrollY > window.innerHeight * VISIBLE_AFTER_VIEWPORT_RATIO);
    };

    const requestUpdate = () => {
        if (rafId === null) {
            rafId = requestAnimationFrame(update);
        }
    };

    const handleClick = () => {
        // Перезапуск анимации «запуска», если по кнопке кликнули повторно
        $button.classList.remove("is-launching");
        void $button.offsetWidth;
        $button.classList.add("is-launching");

        const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        window.scrollTo({ top: 0, behavior: reduceMotion ? "auto" : "smooth" });
    };

    const handleAnimationEnd = (e) => {
        if (e.target === $button) {
            $button.classList.remove("is-launching");
        }
    };

    $button.addEventListener("click", handleClick);
    $button.addEventListener("animationend", handleAnimationEnd);

    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate, { passive: true });

    update();
}
